import genel001 from '../imageproje/TeamImage/AliMetin.avif';
import genel002 from '../imageproje/TeamImage/senolKayrak.avif';
import genel003 from '../imageproje/TeamImage/SuatKaraImage.avif';

export const TeamData = [
    { 
        id:'tmdt001',
        name:'Ali Metin', 
        profession:'Emlak Danışmanı', 
        picture:genel001,
        href:'/hakkımızda/ekibimiz/ali-metin',
        content:'Başarıları, 25 yılı aşkın yurt içi ve dışı gayrimenkul sektör deneyimini doğrudan yansımasıdır.',
        phone:'tel:+905322005989',
        email:'mailto:ali.metin@emlakcinn.com'
    },
    { 
        id:'tmdt002',
        name:'Şenol Kayrak', 
        profession:'Emlak Danışmanı', 
        picture:genel002,
        href:'/hakkımızda/ekibimiz/şenol-kayrak',
        content:"Emlakçın'ın benzersiz ve sıra dışı bir emlak piyasası var. Kazanmanıza yardımcı olmak için burada.",
        phone:'tel:+905360179017',
        email:'mailto:info@emlakcinn.com'
    },
    { 
        id:'tmdt003',
        name:'Suat Kara', 
        profession:'Emlak Danışmanı', 
        picture:genel003,
        href:'/hakkımızda/ekibimiz/suat-kara',
        content:"2020 yılından bu yana Çatalca'daki gayrimenkulleri tavizsiz bir dürüstlükle satıyor.",
        phone:'tel:+905455401717',
        email:'mailto:info@emlakcinn.com'
    }
]


export default TeamData;